export default __webpack_public_path__ + "4a2413596073ac34f6d464ce8cdc539c.png";